<div class="xtradts suprt mbott">
    <div class="basicrow msidespad">  
        <div class="b-title">
            <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
            <div class="tabcell">
                Soporte
            </div>
            </div>
        </div>
        </div>
        <div class="basicrow msidespad">
        <a routerLink="/frequentquestions" class="btns bgray vcenter">
            <span class="tabcell">
                Ir&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
        </a>
    </div>
</div>